import { DialogM } from "@common/components/alert/dialog/Dialog"
import { theme } from "@common/theme/theme"
import { getFromStorage, setToStorage } from "@data/utility/asyncStorageUtils"
import { useNavigation } from "@react-navigation/native"
import moment from "moment"
import { useEffect } from "react"
import { connect } from "react-redux"
import { availabilityNudgeFromState } from "./maDispoSlot"

// One reminder per calendar month, persisted locally (no server flag).
const LAST_SHOWN_MONTH_KEY = "@ma_dispo_monthly_reminder_month"

/**
 * Monthly « Ma dispo » reminder — a once-per-month popup, on the tutor's first
 * connection of the month, nudging them to keep their semaine-type up to date.
 * Renders nothing; it fires an imperative dialog on mount when due. Only shown to
 * the tutors the shared nudge rule targets (no point nagging an up-to-date tutor,
 * nor one who wants no new group).
 */
const MaDispoMonthlyReminder = ({ isDue }) => {
    const navigation = useNavigation()

    useEffect(() => {
        if (!isDue) return

        let mounted = true
        const currentMonth = moment().format("YYYY-MM")

        getFromStorage(LAST_SHOWN_MONTH_KEY).then((lastShown) => {
            if (!mounted || lastShown === currentMonth) return
            // Stamped only once the popup is actually up: burning the month before
            // showing it silences the reminder for a tutor who never saw it.
            DialogM.show({
                text1: "Confirme tes créneaux",
                text2: "Une fois par semaine, pour continuer à recevoir des propositions de groupes.",
                buttonText1: "Confirmer",
                buttonColor1: theme.colors.primary,
                onPress: () => navigation.push("tutor/ma-dispo"),
                buttonText3: "Plus tard",
                exitButton: true,
                onPressBack: () => {},
            })
            setToStorage(LAST_SHOWN_MONTH_KEY, currentMonth)
        })

        return () => {
            mounted = false
        }
    }, [isDue])

    return null
}

const mapStateToProps = (state) => ({
    isDue: availabilityNudgeFromState(state),
})

export default connect(mapStateToProps)(MaDispoMonthlyReminder)
